<template>
  <b-icon-info-circle variant="blue-500" class="mr-2 mt-1"></b-icon-info-circle>
  <span class="text-md text-blue-500">{{ $t('donorForm.form.phoneDescription') }}</span>
</template>
